import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import PortfolioList from '../../components/admincomponents/PortfolioList';

function AdminBlogs({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <PortfolioList  />            
    </>
  );
}

export default AdminBlogs;
